export const SEND_MERCHANT_APPLICATION_ERROR = gql`
    mutation sendMerchantApplicationError($input: SendMerchantApplicationErrorInput!) {
        sendMerchantApplicationError(input: $input) {
            id
        }
    }
`;
